// Customizable Area Start
import React from "react";
import { createStyles, Theme } from "@material-ui/core/styles";
import {
  Container,
  Box,
  Typography,
  Button,
  IconButton,
  withStyles,
  CircularProgress,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CreateEveryreelConfirmController, {
  Props,
} from "./CreateEveryreelConfirmController.web";
import { CheckRounded, CloseRounded } from "@material-ui/icons";
import { NewEveryreelSteps } from "./enums";
import PlayCircleFilledRoundedIcon from '@material-ui/icons/PlayCircleFilledRounded';

const styles = (theme: Theme) =>
  createStyles({
    modal: {
      position: "relative",
      display: "flex",
      flexBasis: "809px",
      padding: "60px 44px 40px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "22px",
      flexShrink: 0,
      borderRadius: "8px 8px 32px 8px",
      background: "#FFF",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        minHeight: "100%",
      },
      [theme.breakpoints.down(650)]: {
        padding: "0px"
      },
    },

    closeButton: {
      position: "absolute",
      top: "20px",
      right: "11px",
    },

    modalTitle: {
      alignSelf: "flex-start",
      fontSize: "32px",
      lineHeight: "32px",
      fontWeight: 700,
      letterSpacing: "-0.12px",
      [theme.breakpoints.down(650)]: {
        fontSize: '24px'
      },
    },

    previewContainer: {
      position: "relative",
    },

    imagePreview: {
      display: "flex",
      maxWidth: "320px",
      minWidth: "280px",
      height: "500px",
      borderRadius: "20px",
      overflow: "hidden",
      background: "#F2F2F2",

      "& > img": {
        objectFit: "cover",
      },

      "& video": {
        width: "100%",
        objectFit: "contain",
      },
    },

    videoWrapper: {
      display: "flex",
      position: "relative",
    },

    videoControlButton: {
      position: 'absolute',
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },

    controlInnerButton: {
      padding: "2px",
     "& svg": {
       color: "rgba(255, 255, 255, 0.8)",
        fontSize: "90px"
     }
    },

    buttonsContainer: {
      position: "absolute",
      bottom: "29px",
      left: "50%",
      transform: "translate(-50%, 0)",
      display: "flex",
      gap: "41px",
    },

    button: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "55px",
      minWidth: "55px",
      height: "55px",
      borderRadius: "8px",
      backgroundColor: "#FFF",
    },
  });

class CreateEveryreelConfirm extends CreateEveryreelConfirmController {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { files, classes, setStep, closeModal } = this.props;
    const { isPlaying } = this.state;

    return (
      <Container
        id="confirmFileContainer"
        maxWidth={false}
        className={classes.modal}
        onClick={(e) => e.stopPropagation()}
      >
        <IconButton
          id="closeModalButton"
          className={classes.closeButton}
          disabled={this.props.uploadFunnelFilesLoading}
          onClick={closeModal}
        >
          <CloseIcon />
        </IconButton>
        <Typography className={classes.modalTitle}>
          {this.goodChoice}
        </Typography>
        <Box className={classes.previewContainer}>
          <Box className={classes.imagePreview}>
            {Boolean(files.length) &&
              (files[files.length - 1].type.includes("image") ? (
                <img
                  className={classes.imagePreview}
                  src={files[0].preview}
                  alt="image preview"
                />
              ) : (
                <Box
                  data-test-id="video-wrapper"
                  className={classes.videoWrapper}
                  onClick={this.handleVideoToggle}
                >
                  <video ref={this.videoRef} controls={false}>
                    <source src={files[files.length - 1].preview} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <Box
                    hidden={isPlaying}
                    data-test-id="video-play-button"
                    className={classes.videoControlButton}
                    onClick={this.handleVideoToggle}
                  >
                    <IconButton className={classes.controlInnerButton}>
                      <PlayCircleFilledRoundedIcon />
                    </IconButton>
                  </Box>
                </Box>
              ))}
          </Box>

          <Box className={classes.buttonsContainer}>
            <Button
              id="confirmFilesButton"
              className={classes.button}
              disabled={this.props.uploadFunnelFilesLoading}
              onClick={() => {
                this.handleSendFunnelFiles()
              }}
            >
              {this.props.uploadFunnelFilesLoading ? (
                <CircularProgress style={{ color: "#FFC629" }} size={20} />
              ) : (
                <CheckRounded style={{ color: "#059669", width: 25 }} />
              )}
            </Button>
            <Button
              id="rejectFilesButton"
              className={classes.button}
              disabled={this.props.uploadFunnelFilesLoading}
              onClick={() => setStep(NewEveryreelSteps.SELECT_FILE)}
            >
              <CloseRounded style={{ color: "#DC2626", width: 25 }} />
            </Button>
          </Box>
          {this.props.uploadFunnelFilesError ? (
            <p style={{ color: "#DC2626", fontSize: 13, textAlign: "center", margin: "8px 0 0" }}>
              {this.props.uploadFunnelFilesError}
            </p>
          ) : null}
        </Box>
      </Container>
    );
  }
}

export { CreateEveryreelConfirm };
export default withStyles(styles)(CreateEveryreelConfirm);
// Customizable Area End
